import * as React from 'react'
import { Input, Typography } from 'antd'
import { PerimResponsabilite } from './MainCSoftAccess'
const { Text } = Typography

interface IProps {
  perimResponsabilite:    PerimResponsabilite
  setPerimResponsabilite: React.Dispatch<React.SetStateAction<PerimResponsabilite>>
}

export default function CPerimResponsabilities(props: IProps){

    return (
    <div>
        {['1','2','3','4','5'].map((idRang: string) => (
          <div key={idRang} className="div-text-input">
            <Text className='text-before-input'>Rang {idRang} (mettre au pluriel)</Text>
            <Input
                id       = {`perim_responsabilite_rang${idRang}`}
                style    = {{borderRadius: '4px'}}
                value    = {props.perimResponsabilite.perim_responsabilite[`rang${idRang}`]}
                onChange = {(e) => {
                  props.setPerimResponsabilite({
                    ...props.perimResponsabilite,
                    perim_responsabilite: {
                      ...props.perimResponsabilite.perim_responsabilite,
                      [`rang${idRang}`]: e.target.value
                    }
                  })
                }}
            />
          </div>
        ))}
    </div>
    )                   
}
